import React from "react";
import { useCollection } from "react-firebase-hooks/firestore";
import { auth, db } from "firebaseApp";
import { query, collection, orderBy, where } from "firebase/firestore";
import Loader from "components/react-lib/generic-ui/Loader";
import { CircularProgress, Grid, Stack, Typography } from "@mui/material";
import ImageGeneration from "./ImageGeneration";
import { useTheme } from "@emotion/react";
import { fonts } from "../../fonts";
import { useSelector } from "react-redux";
import { selectQueryState } from "../../store/firestore";

export default function GenerationGallery({ menuItems = [] }) {
  const theme = useTheme();
  const generatedImagesState = useSelector((state) =>
    selectQueryState(state, "generatedImages")
  );

  if (generatedImagesState.loading) {
    return (
      <Stack alignItems="center" justifyContent="center" spacing={1}>
        <CircularProgress />
        <Typography
          variant="caption"
          sx={{
            color: theme.palette.text.main,
          }}
        >
          Loading your images.
        </Typography>
      </Stack>
    );
  }

  if (generatedImagesState.docs.length === 0) {
    return (
      <Typography
        fontFamily={fonts.anton}
        sx={{
          color: theme.palette.text.main,
        }}
      >
        You haven't generated any image yet.
      </Typography>
    );
  }

  return (
    <Grid
      container
      spacing={1}
      px={4}
      sx={{
        overflowY: "auto",
        flexGrow: 1,
      }}
    >
      {generatedImagesState.docs.map((imageGeneration) => (
        <Grid
          item
          key={imageGeneration.id}
          xs={12}
          sm={6}
          md={3}
          lg={3}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <ImageGeneration imageGeneration={imageGeneration} menuItems={menuItems} />
        </Grid>
      ))}
    </Grid>
  );
}
